import { sectionForMenuId, type SidebarSection } from './sidebarSections';
import type { PermissionCode } from '../../../lib/permissions';
import type { Menu } from './types';

export interface MenuSearchEntry {
    caption: string;
    section: SidebarSection;
    path?: string;
    url?: string;
    params?: Record<string, any>;
    privilege?: number;
    permission?: PermissionCode;
    module?: string;
    external?: boolean;
    /** Título del menú padre, para mostrarlo como miga de pan. */
    parentCaption?: string;
}

/**
 * Aplana los menús en una lista de entradas buscables. Los menús de primer
 * nivel sólo generan entrada si son navegables (los que existen únicamente
 * para agrupar submenús no llevan a ninguna parte); los submenús heredan la
 * sección del padre y guardan su título como miga de pan. Se preserva el
 * orden original: padre seguido de sus hijos.
 */
export function flattenMenusForSearch(menus: Menu[]): MenuSearchEntry[] {
    const entries: MenuSearchEntry[] = [];

    for (const menu of menus) {
        const section = sectionForMenuId(menu.id);

        if (menu.path || menu.url) {
            entries.push({
                caption: menu.caption,
                section,
                path: menu.path,
                url: menu.url,
                params: menu.params,
                privilege: menu.privilege,
                permission: menu.permission,
                module: menu.module,
                external: menu.external,
            });
        }

        for (const submenu of menu.submenus ?? []) {
            entries.push({
                caption: submenu.caption,
                section,
                path: submenu.path,
                url: submenu.url,
                params: submenu.params,
                privilege: submenu.privilege,
                permission: submenu.permission,
                module: submenu.module,
                external: submenu.external,
                parentCaption: menu.caption,
            });
        }
    }

    return entries;
}
